<template>
  <div>
    <v-form novalidate ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="getEntity"
        :label="entityRef"
        required
        filled
        disabled
      ></v-text-field>
      <v-text-field
        :label="getProduct"
        required
        filled
        append-icon="mdi-view-list"
        disabled
      ></v-text-field>

      <v-text-field
        :label="getPrice + ' AKZ'"
        required
        filled
        append-icon="mdi-cash"
        disabled
      ></v-text-field>
      <v-text-field
        v-show="getButtonOnline"
        v-model="cellphone"
        :rules="!getButtonOnline ? novalidRules : cellphoneRules"
        label="Telefone Móvel"
        required
        filled
        placeholder="Telefone móvel registado no Express"
        :disabled="!getButtonOnline"
        ref="cellphone"
      ></v-text-field>

      <v-text-field
        v-model="reference"
        :rules="refRules"
        label="Referência"
        required
        filled
        placeholder="Ex: pagamento de bens"
        :disabled="disabled"
        ref="refrence"
      ></v-text-field>

      <v-card-actions>
        <v-btn
          color="deep-purple lighten-2"
          text
          block
          @click="submitPay"
          :disabled="!valid"
          :loading="loading"
        >
          Pagar
        </v-btn>
      </v-card-actions>
    </v-form>
  </div>
</template>

<script>
import eventBus from "../../main";
import { mapHelper } from "@/store/helper";

export default {
  name: "FormPay",
  data: () => ({
    value: true,
    entityRef: "Seu pagamento irá para:",
    valid: true,
    otp: "",
    loading: false,
    disabled: false,
    reference:"",
    cellphone: "",
    refRules: [
      v => !!v || "Referêcia é obrigatória",
      v => (v && v.length >= 6) || "Deve ter no mínimo 6 caracter"
    ],
    username: "",
    emailRules: [
      v => !!v || "Utilizador é requerido",
      v => /.+@.+\..+/.test(v) || "Utilizador inválido"
    ],
    cellphoneRules: [
      v => !!v || "Telefone é requerido",
      v => /^[9]+[1-9]\d{7}$/.test(v) || "Telefone inválido"
    ],
    novalidRules: [v => /.*/.test(v)]
  }),

  methods: {
    submitPay() {
      if(!this.$store.getters.getPrice){
        let payload = {
          color: "error",
          text: "Produto inválido",
          errorLogin: true
        };
        eventBus.$emit("openInfo", payload); // emit the event to the bus
        return
      }
      if (this.$refs.form.validate()) {
        let payload = {
          reference: this.reference,
          cellphone: this.cellphone
            ? this.cellphone
            : this.$store.getters.getCellphoneH1,
          payType: this.$store.getters.getButtonWallet ? "wlt" : "mcx"
        };
        this.$store.dispatch("saveDataEntityComplete", payload);
        eventBus.$emit("openPin", true);
      }
    },
    sleep: function(m) {
      return new Promise(resolve => setTimeout(resolve, m));
    },
    // emitPay() {
    //   if (this.referencia) {
    //     this.sleep(2000).then(() => {
    //       this.loading = false;
    //       this.disabled = false;
    //       this.openConfirm();
    //       this.disabled = false;
    //       return false;
    //     });
    //   } else {
    //     this.sleep(3000).then(() => {
    //       this.loading = false;
    //       this.disabled = false;
    //       return false;
    //     });
    //   }
    // },
    // openConfirm() {
    //   eventBus.$emit("openConfirmPay", {
    //     setPay: true,
    //     referencia: this.$refs.refrence.value
    //   });
    // },
    close() {
      return (this.errorLogin = false);
    }
  },

  mounted() {
    if(this.$store.getters.getEntity.toLowerCase() === "agente recargas sys factory"){
      this.reference = "Recarga";
    }
  },
  created() {
    const self = this;
    self.$store.dispatch("getBankAccount");
    eventBus.$on("openWpayment", function(value) {
      self.modal = value;
    });
  },
  computed: {
    ...mapHelper
  }
};
</script>

<style scoped></style>
